module.exports = __webpack_public_path__ + "static/fonts/helveticaneuelight.d9f1d23.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/helveticaneuelight.woff2
// module id = 1098
// module chunks = 5